export default __webpack_public_path__ + "static/media/330_store05-it-mobile.ed926152.png";